import { HTTP } from "./common";

export const PfApi = {
  get(id) {
    return HTTP.get(`planfix/local/?${id?'project_id='+id:''}`).then((response) => {
      return response.data;
    });
  }
};
